function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { Fragment } from 'react';
import { string, arrayOf, shape, oneOfType, bool, number, func } from 'prop-types';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import { VIEW_RATE_INFORMATION_FOR, PRICE_PER_EXTRA_PER, RATES_TITLE } from "../../../utils/default-strings";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { Dropdown } from "../../inputs/Dropdown";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { GridRow } from "../../layout/GridRow";
import { ShowOn } from "../../layout/ShowOn";
import { Table } from "../../collections/Table";
import { getRoomTypeDropdownMarkup } from "./utils/getRoomTypeDropdownMarkup";
import { getCurrencyDropdownPlaceholderMarkup } from "./utils/getCurrencyDropdownPlaceholderMarkup";
import { getCardsPlaceholderMarkup } from "./utils/getCardsPlaceholderMarkup";
import { getMobileRateRowMarkup } from "./utils/getMobileRateRowMarkup";
import { getTablePlaceholderMarkup } from "./utils/getTablePlaceholderMarkup";
import { getRateCategoryHeadingMarkup } from "./utils/getRateCategoryHeadingMarkup";
export var Component = function Component(_ref) {
  var costPerExtraGuestLabel = _ref.costPerExtraGuestLabel,
      currencyNoResultsText = _ref.currencyNoResultsText,
      currencyOptions = _ref.currencyOptions,
      currencyValue = _ref.currencyValue,
      isShowingPlaceholder = _ref.isShowingPlaceholder,
      onChangeCurrency = _ref.onChangeCurrency,
      onChangeRoomType = _ref.onChangeRoomType,
      rateCategories = _ref.rateCategories,
      rateHeadings = _ref.rateHeadings,
      roomTypeInputLabel = _ref.roomTypeInputLabel,
      roomTypes = _ref.roomTypes,
      roomTypesValue = _ref.roomTypesValue,
      title = _ref.title;
  return React.createElement(Fragment, null, React.createElement("h3", null, title), roomTypes && getRoomTypeDropdownMarkup(isShowingPlaceholder, roomTypes, onChangeRoomType, roomTypeInputLabel, roomTypesValue), React.createElement(ShowOn, {
    mobile: true
  }, isShowingPlaceholder ? getCurrencyDropdownPlaceholderMarkup() : React.createElement(Dropdown, {
    isClearable: false,
    isSearchable: true,
    noResultsText: currencyNoResultsText,
    onChange: onChangeCurrency,
    options: currencyOptions,
    value: currencyValue
  }), isShowingPlaceholder ? getCardsPlaceholderMarkup() : rateCategories.map(function (rateCategory, rateCategoryIndex) {
    return React.createElement(Card, {
      fluid: true,
      key: buildKeyFromStrings(rateCategory.name, rateCategoryIndex)
    }, React.createElement(Card.Content, null, React.createElement(Grid, {
      padded: true
    }, React.createElement(GridRow, null, React.createElement(GridColumn, {
      width: 12
    }, getRateCategoryHeadingMarkup(rateCategory, costPerExtraGuestLabel))), rateCategory.rates.map(function (rate, rateIndex) {
      return getMobileRateRowMarkup(rate, rateHeadings[rateIndex], buildKeyFromStrings(rateCategory.name, rate, rateIndex));
    }))));
  })), React.createElement(ShowOn, {
    computer: true,
    tablet: true,
    widescreen: true
  }, isShowingPlaceholder ? getTablePlaceholderMarkup() : React.createElement(Table, {
    tableBody: rateCategories.map(function (rateCategory) {
      return [getRateCategoryHeadingMarkup(rateCategory, costPerExtraGuestLabel)].concat(_toConsumableArray(rateCategory.rates));
    }),
    tableHeadings: [React.createElement(Dropdown, {
      isClearable: false,
      isSearchable: true,
      noResultsText: currencyNoResultsText,
      onChange: onChangeCurrency,
      options: currencyOptions,
      value: currencyValue
    })].concat(_toConsumableArray(rateHeadings))
  })));
};
Component.defaultProps = {
  costPerExtraGuestLabel: PRICE_PER_EXTRA_PER,
  currencyNoResultsText: undefined,
  currencyValue: undefined,
  isShowingPlaceholder: false,
  onChangeCurrency: Function.prototype,
  onChangeRoomType: Function.prototype,
  roomTypeInputLabel: VIEW_RATE_INFORMATION_FOR,
  roomTypes: null,
  roomTypesValue: undefined,
  title: RATES_TITLE
};
Component.displayName = 'Rates';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  costPerExtraGuestLabel: string,
  currencyNoResultsText: string,
  currencyOptions: arrayOf(shape({
    text: string.isRequired,
    value: oneOfType([bool, number, string])
  })).isRequired,
  currencyValue: oneOfType([bool, number, string]),
  isShowingPlaceholder: bool,
  onChangeCurrency: func,
  onChangeRoomType: func,
  rateCategories: arrayOf(shape({
    costPerExtraGuest: string,
    dateRange: string,
    name: string.isRequired,
    numberOfGuests: string,
    rates: arrayOf(string)
  })).isRequired,
  rateHeadings: arrayOf(string).isRequired,
  roomTypeInputLabel: string,
  roomTypes: arrayOf(shape({
    imageSizes: string,
    imageSrcSet: string,
    imageUrl: string,
    text: string.isRequired,
    value: oneOfType([bool, number, string])
  })),
  roomTypesValue: oneOfType([bool, number, string]),
  title: string
} : {};